import { Button } from "@mantine/core";
import { IconPlus } from "@tabler/icons-react";
import { Link, useParams } from "react-router-dom";
import { useLanguage } from "../../../stores/LanguageStore";

const CreateFileButton = () => {
  const lang = useLanguage((s) => s.language);
  const { folderId } = useParams();
  const route = folderId
    ? `/settings/tools/files/folder/${folderId}/file/create`
    : `create`;

  return (
    <Button
      leftSection={<IconPlus size={18} />}
      radius={"md"}
      color="primary"
      component={Link}
      to={route}
      size="md"
    >
      {lang.files.create.button_tooltip}
    </Button>
  );
};

export default CreateFileButton;
